// Mock data - Arabell Group

export const COMPANY = {
  name: "Arabell Group",
  fullLegalName: "ARABELL GROUP",
  shortName: "Arabell Group",
  legalAddress: "Via Marie Curie 17, 39100 Bolzano (BZ) – Italia",
  capitaleSociale: "€ 250.000 i.v.",
  pIva: "03062850999",
  cf: "03062850999",
  rea: "BZ - 253230",
  pec: "arabellgroupsrls@legalmail.it",
  sdiCode: "QULXG4S",
  formaGiuridica: "Società",
  whatsapp: "+39 352 0721132",
  whatsappRaw: "393520721132",
  email: "info@arabellgroup.com",
  logoUrl: "/arabell-logo-clean.png",
  iconUrl: "/arabell-icon.png",
  tagline: "Move the World",
};

// Hero carousel slides
export const HERO_SLIDES = [
  {
    id: 1,
    image: "/hero/supercar.jpg",
    title: "Arabell Group",
    subtitle: "Move the World",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1655286029136-95a47d455999?auto=format&fit=crop&w=2400&q=80",
    title: "Yachting Division",
    subtitle: "Sail beyond the ordinary",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1566212774847-025968e5bf56?auto=format&fit=crop&w=2400&q=80",
    title: "Aviation Division",
    subtitle: "The sky is no limit",
  },
  {
    id: 4,
    image: "https://images.pexels.com/photos/3195642/pexels-photo-3195642.jpeg?auto=compress&cs=tinysrgb&w=2400",
    title: "Real Estate",
    subtitle: "Italian luxury heritage",
  },
  {
    id: 5,
    image: "https://images.pexels.com/photos/17377921/pexels-photo-17377921.jpeg?auto=compress&cs=tinysrgb&w=2400",
    title: "Prime Care",
    subtitle: "Care perfection",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1720962158937-7ea890052166?auto=format&fit=crop&w=2400&q=80",
    title: "Technology Division",
    subtitle: "Crafting next-generation digital products",
  },
  {
    id: 7,
    image: "/hero/longterm.jpg",
    title: "Long-Term Lease · Targa Estera",
    subtitle: "Supercar a lungo termine, targa estera",
  },
  {
    id: 8,
    image: "/hero/cargo.jpg",
    title: "Cargo & Logistics",
    subtitle: "Closed auto transport + soccorso stradale H24",
  },
  {
    id: 9,
    image: "/hero/wallet.jpg",
    title: "Arabell Credit Wallet",
    subtitle: "Il wallet digitale dei membri Arabell",
  },
  {
    id: 10,
    image: "https://images.pexels.com/photos/7100326/pexels-photo-7100326.jpeg?auto=compress&cs=tinysrgb&w=2400",
    title: "Kartoonia by Arabell",
    subtitle: "Family & Kids — ludoteca indoor e feste",
  },
  {
    id: 11,
    image: "https://images.pexels.com/photos/12999485/pexels-photo-12999485.jpeg?auto=compress&cs=tinysrgb&w=2400",
    title: "Exclusive Members Club",
    subtitle: "An invitation only experience",
  },
];

export const DIVISIONS = [
  {
    id: "supercar",
    title: "Arabell Supercar & Luxury Division",
    image: "/hero/supercar.jpg",
    description: "Vendita e noleggio di supercar e auto premium, anche nuove e usate certificate, per esperienze esclusive in tutta Europa. Permuta, finanziamento e consegna a domicilio.",
    span: "md:col-span-2",
  },
  {
    id: "yuppirent",
    title: "Yuppi-Rent · Noleggio Low Cost",
    image: "/yuppi/card-dark.jpg",
    logo: "/yuppi/logo-mark.png",
    description: "Noleggio a breve termine anche senza carta di credito: da €5 al giorno, km illimitati, zero cauzione e cancellazione gratuita, in tutto il mondo.",
    span: "md:col-span-2",
    ctaKey: "services.yuppi_cta",
  },
  {
    id: "urban",
    title: "Arabell Urban Mobility Division",
    image: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?auto=format&fit=crop&w=1400&q=80",
    description: "Mobilità urbana premium: noleggi a breve e lungo termine per la città.",
    span: "",
  },
  {
    id: "corporate",
    title: "Arabell Corporate & Utility Fleet Division",
    image: "https://images.unsplash.com/photo-1566348103654-df045b5cf027?auto=format&fit=crop&w=1400&q=80",
    description: "Flotte aziendali, van premium e veicoli utility per imprese e professionisti.",
    span: "",
  },
  {
    id: "yachting",
    title: "Arabell Yachting Division",
    image: "https://images.unsplash.com/photo-1655286029136-95a47d455999?auto=format&fit=crop&w=1800&q=80",
    description: "Charter di yacht e mega-yacht nelle destinazioni più esclusive del Mediterraneo.",
    span: "",
  },
  {
    id: "aviation",
    title: "Arabell Aviation Division",
    image: "https://images.unsplash.com/photo-1566212774847-025968e5bf56?auto=format&fit=crop&w=1400&q=80",
    description: "Jet privati on-demand. Voli executive con servizio di concierge dedicato.",
    span: "",
  },
  {
    id: "realestate",
    title: "Arabell Real Estate Division",
    image: "https://images.pexels.com/photos/3195642/pexels-photo-3195642.jpeg?auto=compress&cs=tinysrgb&w=1400",
    description: "Property management, investimenti e compravendita di immobili di prestigio.",
    span: "",
  },
  {
    id: "primecare",
    title: "Prime Care Studio",
    image: "https://images.pexels.com/photos/17377921/pexels-photo-17377921.jpeg?auto=compress&cs=tinysrgb&w=1400",
    description: "Care perfection: cura premium dedicata alla tua vettura.",
    span: "",
  },
  {
    id: "technology",
    title: "Arabell Technology Division",
    image: "https://images.unsplash.com/photo-1720962158937-7ea890052166?auto=format&fit=crop&w=1800&q=80",
    description: "Crafting next-generation digital products. Software, piattaforme e soluzioni digitali avanzate.",
    span: "",
  },
  {
    id: "wallet",
    title: "Arabell Credit Wallet",
    image: "/hero/wallet.jpg",
    description: "Il wallet digitale dei membri Arabell. Credito, vantaggi e prenotazioni rapide.",
    span: "",
  },
  {
    id: "longterm",
    title: "Arabell Long-Term Lease · Targa Estera",
    image: "/hero/longterm.jpg",
    description: "Noleggio a lungo termine con targa estera: supercar e luxury car con fiscalità ottimizzata.",
    span: "",
  },
  {
    id: "cargo",
    title: "Arabell Cargo & Logistics",
    image: "/hero/cargo.jpg",
    description: "Closed auto transport per supercar, soccorso stradale H24 e cargo B2B in tutta Europa.",
    span: "",
  },
  {
    id: "kartoonia",
    title: "Kartoonia by Arabell",
    image: "https://images.pexels.com/photos/7100326/pexels-photo-7100326.jpeg?auto=compress&cs=tinysrgb&w=1400",
    description: "La divisione Family & Kids del Gruppo: ludoteca indoor, feste di compleanno e vantaggi dedicati ai membri Arabell.",
    span: "",
  },
  {
    id: "members",
    title: "Arabell Exclusive Members Club",
    image: "https://images.pexels.com/photos/12999485/pexels-photo-12999485.jpeg?auto=compress&cs=tinysrgb&w=1800",
    description: "Membership esclusiva con benefici dedicati su tutti i servizi del Gruppo. An invitation only experience.",
    span: "md:col-span-2",
  },
];

export const FOOTER_LINKS = {
  primary: [
    { label: "Supercar & Luxury Division", href: "/supercar-luxury" },
    { label: "Long-Term Lease", href: "/long-term-de" },
    { label: "Cargo & Logistics", href: "/cargo" },
    { label: "Soccorso Stradale H24", href: "/soccorso-stradale" },
    { label: "Kartoonia · Family & Kids", href: "/kartoonia" },
    { label: "Prime Care", href: "/prime-care" },
    { label: "Contattaci", href: "/contatti" },
  ],
  secondary: [
    { label: "Chi Siamo", href: "/chi-siamo" },
    { label: "Magazine", href: "/blog" },
    { label: "Press & Media", href: "/press" },
    { label: "Careers & Opportunities", href: "/careers" },
    { label: "Recensioni", href: "/recensioni" },
  ],
  legal: [
    { label: "Termini e Condizioni", href: "/termini-e-condizioni" },
    { label: "Cookie Policy", href: "/cookie-policy" },
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Cancellation Policy", href: "/cancellation-policy" },
  ],
};

export const EXPLORE_MENU = [
  { label: "Chi Siamo", href: "/chi-siamo" },
  { label: "Supercar & Luxury", href: "/supercar-luxury" },
  { label: "Long-Term Lease", href: "/long-term-de" },
  { label: "Yuppi-Rent · Noleggio Low Cost", href: "/noleggio-low-cost" },
  { label: "Urban Mobility", href: "/urban-cars" },
  { label: "Corporate Fleet", href: "/corporate-fleet" },
  { label: "Cargo & Logistics", href: "/cargo" },
  { label: "Yachting", href: "/yachts" },
  { label: "Aviation", href: "/aviation" },
  { label: "Real Estate", href: "/real-estate" },
  { label: "Prime Care", href: "/prime-care" },
  { label: "Technology", href: "/technology" },
  { label: "Credit Wallet", href: "/credit-wallet" },
  { label: "Members Club", href: "/membership" },
  { label: "Kartoonia · Family & Kids", href: "/kartoonia" },
  { label: "Magazine", href: "/blog" },
  { label: "Recensioni", href: "/recensioni" },
  { label: "Contattaci", href: "/contatti" },
];
